import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class HtmlModifier extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get property() {
    return get(this, '_property.options[0].name', '');
  }

  get value() {
    return get(this, '_value.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/HtmlModifier.model.js